import React from "react";
import { Accordion } from "bootstrap"; // do not remove. Needed for accordion to function

export const BootstrapAccordion = ({ children, accordionId }) => (
  <article className="accordion" id={accordionId}>
    {children}
  </article>
);

export const BoostrapAccordionItem = ({ children }) => {
  return <article className="accordion-item">{children}</article>;
};

export const AccordionItemHeader = ({ children, itemId }) => {
  return (
    <section className="accordion-header" id={`heading-${itemId}`}>
      <button
        className="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`#${itemId}`}
        aria-expanded="false"
        aria-controls={`${itemId}`}
      >
        {children}
      </button>
    </section>
  );
};

export const AccordionItemBody = ({ children, itemId, accordionId }) => {
  return (
    <section
      id={`${itemId}`}
      className="accordion-collapse collapse"
      aria-labelledby={`heading-${itemId}`}
      data-bs-parent={`#${accordionId}`}
    >
      <div className="accordion-body">{children}</div>
    </section>
  );
};
